

import React, { useEffect, useState } from "react";
import TableComponent from "../../components/TableComponent";
import ApiCustom from "../../utils/ApiCustom";
import { formatDate } from "../../utils/helps";
import AuditHistoryButton, {
  canViewAuditHistory,
} from "../../components/admin/AuditHistoryButton";

const PointLog = () => {
  const [pointLogs, setPointLogs] = useState([]);
  const [selectedCriteria, setSelectedCriteria] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    ApiCustom("/point-log-show")
      .then((res) => {
        setPointLogs(res.data?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const headers = [
    {
      key: "id",
      label: "STT",
      render: (item, index) => (
        <div>
          <p className="font-medium">{index + 1}</p>
        </div>
      ),
    },
    {
      key: "user",
      label: "Hội viên",
      render: (item) => (
        <div>
          <p className="font-medium">{item?.company?.companyName}</p>
        </div>
      ),
    },
    {
      key: "criteria",
      label: "Tiêu chí",
      render: (item) => (
        <div>
          <p className="font-medium">{item.criteria?.name}</p>
        </div>
      ),
    },
    {
      key: "point",
      label: "Điểm tiêu chí",
      render: (item) => (
        <div>
          <p className="font-medium">{item.recordedPoint}</p>
        </div>
      ),
    },
    {
      key: "reason",
      label: "Lý do",
      render: (item) => (
        <div>
          <p className="font-medium">{item.reason}</p>
        </div>
      ),
    },
    {
      key: "createdAt",
      label: "Ngày thực hiện",
      render: (item) => (
        <div>
          <p className="font-medium">{formatDate(item.createdAt)}</p>
        </div>
      ),
    },
  ];

  if (canViewAuditHistory()) {
    headers.push({ key: "setting", label: "Thao tác" });
  }

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        <AuditHistoryButton
          module="POINT"
          entityType="PointLog"
          entityId={item.id}
        />
      </div>
    ),
  };

  const filterCriteriaName = [
    ...new Set(
      pointLogs
        .map((item) => item.criteria?.name)
        .filter((name) => name !== undefined && name !== null)
    ),
  ];

  const filterData = pointLogs.filter((item) =>
    selectedCriteria === ""
      ? true
      : [item.criteria?.name].some((field) =>
          field?.toLowerCase().includes(selectedCriteria.toLowerCase())
        )
  );

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold ">Lịch sử cộng điểm hoạt động</h1>
        <select
          className="border p-2 rounded-md"
          onChange={(e) => setSelectedCriteria(e.target.value)}
        >
          <option value="">Chọn tiêu chí</option>
          {filterCriteriaName.map((name, index) => (
            <option key={index} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>
      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={filterData}
          settings={tableSettings}
        />
      </div>
    </div>
  );
};

export default PointLog;



